import React from "react";
import { Sun, Moon, DeviceMobile } from "@phosphor-icons/react";
import { useTheme } from "@/lib/ThemeContext";

/**
 * Three-way segmented control for Light / Dark / Auto.
 * Uses small icons to fit the sidebar footer next to the avatar + role.
 * `compact` mode (used on mobile) shrinks the segments slightly.
 */
const OPTIONS = [
  { key: "light", label: "Light", Icon: Sun },
  { key: "auto", label: "Auto", Icon: DeviceMobile },
  { key: "dark", label: "Dark", Icon: Moon },
];

export default function ThemeToggle({ compact = false, testId = "theme-toggle" }) {
  const { mode, setMode } = useTheme();
  const px = compact ? "px-1.5" : "px-2";
  const h = compact ? "h-7" : "h-8";
  const iconSize = compact ? 14 : 15;

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      data-testid={testId}
      className={`inline-flex items-center gap-0.5 rounded-md border border-zinc-700 bg-zinc-900 p-0.5 ${h}`}
    >
      {OPTIONS.map(({ key, label, Icon }) => {
        const active = mode === key;
        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setMode(key)}
            title={`${label} mode`}
            data-testid={`${testId}-${key}`}
            className={`inline-flex items-center justify-center rounded ${px} h-full transition-colors ${
              active
                ? "bg-zinc-100 text-zinc-900"
                : "text-zinc-400 hover:text-white hover:bg-zinc-800"
            }`}
          >
            <Icon size={iconSize} weight="bold" />
            <span className="sr-only">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
